import { MicrophoneIcon } from '@treams/treams-icons';
import { Spinner } from '@treams/treams-ui';
import { rgba } from 'polished';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const MicrophoneButton = styled(Box)<{ loading?: boolean }>`
	padding: 4px;
	border-radius: 16px;
	background: ${(props) => rgba(props.theme.colors.red, 0.25)};
	transition: 1s cubic-bezier(0, 1, 0, 1) background-color;

	svg {
		display: block;
		width: 24px;
		height: 24px;

		path {
			fill: ${(props) => props.theme.colors.red};
		}
	}

	${(props) =>
		props.loading
			? `
        background: ${props.theme.colors.lightBlueLight};
        padding: 8px;
    `
			: `
        cursor: pointer;

        &:hover {
            background: ${rgba(props.theme.colors.red, 0.5)};
        }
    `}
`;

export default function VoiceMemoButton(props: { loading?: boolean; onClick?: () => void }) {
	return (
		<MicrophoneButton loading={props.loading} width={32} height={32} onClick={props.onClick}>
			{props.loading ? <Spinner /> : <MicrophoneIcon />}
		</MicrophoneButton>
	);
}
